import * as React from 'react';

import { useApplicationContext } from '../../../utils/applicationContext';
import { generateSmartContactPixelUrl } from './generateSmartContactPixelUrl';

export const useSmartContactPixel = (quizCompleted: boolean) => {
  const applicationContext = useApplicationContext();
  const pixelId = applicationContext.config.getStrict<string>('smartContact.pixelId');

  React.useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.defer = true;
    scriptTag.src = generateSmartContactPixelUrl(
      pixelId,
      quizCompleted ? 'application' : 'visit',
      'realtor_e2e_application',
    );
    document.body.appendChild(scriptTag);

    return () => {
      document.body.removeChild(scriptTag);
    };
  }, [quizCompleted, pixelId]);
};
